import React from 'react'

export default function LectureSettingsTipsCard() {
  const tips = [
    {
      title: 'Populate Students',
      icon: 'groups',
      desc: '"Students with Selected Subjects" will filter out students who have not opted for the selected subject during lecture-wise attendance marking. "All Students" will show all enrolled students for the course/batch irrespective of subject selection.',
    },
    {
      title: 'Repeat Lectures',
      icon: 'repeat',
      desc: 'Enable this if your institute repeats a lecture topic across multiple days. When enabled, students who attend any of the repeat sessions are marked present for that topic.',
    },
    {
      title: 'SMS & WhatsApp Automation',
      icon: 'send',
      desc: 'Selecting "Automatic" will instantly dispatch lecture schedule notifications upon saving the entry. "Manual" requires clicking the SMS/WhatsApp icon from the lecture list.',
    },
    {
      title: 'SMS Format (Combined vs Separate)',
      icon: 'chat',
      desc: '"Combined" bundles all scheduled lectures for a student or faculty into a single SMS summary. "Separate" sends an individual notification for each lecture.',
    },
    {
      title: 'Swipe Window Tolerance',
      icon: 'fingerprint',
      desc: 'Defines the valid attendance window around the lecture start time. Students/Faculty swiping within the buffer before or after start time are marked present.',
    },
  ]

  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-outline-variant/25 bg-surface-container-low/50 p-6 shadow-xs">
      <div className="flex items-center gap-2.5 border-b border-outline-variant/20 pb-4">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <span className="material-symbols-outlined text-lg">lightbulb</span>
        </div>
        <div>
          <h3 className="font-display text-base font-extrabold text-on-surface">Configuration Tips</h3>
          <p className="text-xs text-on-surface-variant">System behavior guidelines &amp; best practices</p>
        </div>
      </div>

      <div className="flex flex-col gap-4">
        {tips.map((tip, idx) => (
          <div
            key={idx}
            className="flex gap-3 rounded-2xl border border-outline-variant/20 bg-surface-container-lowest p-4 transition-all hover:border-primary/30 hover:shadow-xs"
          >
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-surface-container-high text-primary">
              <span className="material-symbols-outlined text-base">{tip.icon}</span>
            </div>
            <div className="flex-1">
              <h4 className="text-xs font-black uppercase tracking-wider text-on-surface">{tip.title}</h4>
              <p className="mt-1 text-xs leading-relaxed text-on-surface-variant">{tip.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
